import { render, staticRenderFns } from "./department.vue?vue&type=template&id=3f4e3bba&scoped=true"
import script from "./department.ts?vue&type=script&lang=ts&external"
export * from "./department.ts?vue&type=script&lang=ts&external"
import style0 from "./department.scoped.scss?vue&type=style&index=0&id=3f4e3bba&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4e3bba",
  null
  
)

export default component.exports